const Knowledge = () => {
  return <section className="w-full bg-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mx-auto max-w-4xl text-center">
                    <div>
                        <p className="font-mulish text-sm font-semibold uppercase tracking-[0.3em] text-amber-800">
                            Die Weisheit des Ayurveda
                        </p>
                        <h2 className="mt-5 font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                            Weisheit, die das Leben in Gesundheit führt
                        </h2>
                        <div className="mt-7 space-y-5 font-mulish text-base leading-8 text-gray-700 sm:text-lg">
                            <p>
                                Ayurveda, auf Sanskrit „Weisheit des langen Lebens“ genannt, wurzelt in Altindien und basiert auf Schriften, die mehr als 2500 Jahre alte Traditionen bewahren. Bis heute gilt es als die älteste überlieferte Heilkunde der Welt und hat Einfluss auf die traditionelle chinesische Medizin, die westliche Kräuterkunde und sogar die moderne Medizin.
                            </p>
                            <p>
                                Es ist nicht nur eine Therapie bei Krankheit, sondern eine Art Lebenswissenschaft, die Körper, Geist und Seele ins Gleichgewicht bringt und die natürliche Lebenskraft des Menschen wieder aktiviert.
                            </p>
                        </div>
                        <div className="mt-8  pt-5 font-serif text-xl leading-relaxed text-[#1f4d3c] sm:text-2xl">
                            In diesem „Heim“, weit entfernt vom Alltagslärm, können Sie sich in den natürlichen Rhythmus der Welt zurückziehen und so wieder zu innerer Ruhe und Ausgeglichenheit finden.
                        </div>
                    </div>
                </div>
            </div>
        </section>;
};
export default Knowledge;
